import { ButtonType, DialogFooterButtonsWidget, DialogPositioningBehavior, DialogProps, DialogType, DialogWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CloseAndDismiss, ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';

import { customDomainContentStyle } from '../styles/CustomDomainStyles';

// A utility to open "remove dialog" specific to custom domains.
export const openRemoveDomainDialog= (removeDomain: () => void): void => {
    ReactModalService.openCustom(closeAndDismiss => {
      const dialogProps = ReactModalService.getDefaultDialogProps({
        type: DialogType.NormalWithTitleBar,
        title: Messages.CustomDomainSetting_removeDomainLabel(),
        testId: 'remove-domain-dialog',
        showCloseButton: true,
        dialogWidth: TabDialogWidth.width375px,
        positioningBehavior: DialogPositioningBehavior.Draggable,
        footerContent: getFooterContent(closeAndDismiss, removeDomain)
      }, closeAndDismiss);
      return getDialogWidget(dialogProps);
    });
};

let getFooterContent = (closeAndDismiss: CloseAndDismiss, removeDomain: () => void): React.ReactNode => {
    return (
      <>
      <DialogFooterButtonsWidget
        buttons={[
          {
            handleClick: () => {
              //show pop up and proceed only if 'remove' button is clicked
              closeAndDismiss.close();
              removeDomain();
            },
            buttonType: ButtonType.Destructive,
            children: Messages.CustomDomainSetting_RemoveDialogButton(),
            testId: 'footer-remove',
          }
        ]}
      />
      </>
    );
};

let getDialogWidget = (dialogProps: DialogProps)=> {
    return (
      <DialogWidget {...dialogProps}>
        <div className={customDomainContentStyle}>
          {Messages.CustomDomainSetting_removeDomainDialog()}
        </div>
      </DialogWidget>
    );
};